module.exports = "/_next/static/resources/life1-1422c6b135b7efee468d92bfa6a7d36a.jpg";